@if (show) {
  <app-base-form [fields]="fields"></app-base-form>
}
